// extracted by mini-css-extract-plugin
export var boxItems = "_8h-1";
export var boxItemsLg = "_8h-2";
export var button = "_8h-7";
export var buttonHoverless = "_8h-9";
export var buttonLg = "_8h-8";
export var filterGroupBox = "_8h-0";
export var icon = "_8h-3";
export var iconSecondary = "_8h-6";
export var iconWrapper = "_8h-4";
export var iconWrapperLg = "_8h-5";
export var truncatedLabel = "_8h-a";